<script>

import Layout from "../../../layouts/main";
import appConfig from "@/app.config";
import PageHeader from "@/components/page-header";
import Helper from "@/helpers/helper";

import { useConversionStore } from '@/store/conversionStore';
import { useExchangeStore } from '@/store/exchangeStore'
import { useAggregatorMethodStore } from '@/store/aggregatorMethodStore'

import { ref } from "vue";
import Swal from "sweetalert2";

/**
 * Dashboard Component
 */
export default {
  setup() {
    const doesAddOpen = ref(false);
    const doesEditOpen = ref(false);
    const doesDeleteOpen = ref(false);
    const doesLoadingOpen = ref(false);
    const conversionStore = useConversionStore();
    const exchangeStore = useExchangeStore();
    const aggregatorMethodStore = useAggregatorMethodStore();
          


    return {
      doesAddOpen,
      doesEditOpen,
      doesDeleteOpen,
      doesLoadingOpen,
      conversionStore,
      exchangeStore,
      aggregatorMethodStore,

    };
  },
  page: {
    title: "conversion",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    PageHeader,
  },
  data() {
    return {
      title: "conversion",
      items: [
        {
          text: "Menu",
        },
        {
          text: "conversion",
          active: true,
        },
      ],
      errors: [],
      conversion: {},
      conversions: [],
      managers: [],
      exchanges: [],
      aggregators: [],

      fromAgMethods: [],
      toAgMethods: [],
      rate: "",
      gain: "",
      status: "",
      from_id: "",
      to_id: "",
      exchange_id: "",
      aggregator_id: "",
      fromAgg_id: "",
      toAgg_id: "",
      loading: false,
      lsngth: 0,
      statusHttp: 201,
    };
  },
  methods: {
    toDate(date) {
      return Helper.toDate(date);
    },
  


    
  async loadFromStore() {

      if (!this.conversionStore.list) {
       await  this.conversionStore.loadFromApi(true).then(data => {
        this.conversions = data
        this.conversion_search = data;
         this.length = this.conversions.length;
         console.log(this.conversions)
       })
      } else {
        this.conversions = this.conversionStore.list
        this.conversion_search = this.conversions;
        this.length = this.conversions.length;
      }
  },

 async refresh(){
    await  this.conversionStore.loadFromApi(true).then(data => {
        this.conversions = data
        this.conversion_search = data;
        this.length = this.conversions.length;
    })
  },




    addItem() {
      this.errors = [];
       let body = {
        rate: parseFloat(this.rate),
        gain: parseFloat(this.gain),
        fromAgg: {
          id: this.fromAgg_id,
        },
        toAgg: {
          id: this.toAgg_id,
        },
      };

      if (this.type !== "") {
        body['type'] =  this.type
      }
      this.conversionStore.createItem(body);
      this.conversions = this.conversionStore.list
      this.conversion_search = this.conversions

    },

    editItem() {
      this.errors = [];
      let body = {
        rate: parseFloat(this.rate),
        gain: parseFloat(this.gain),
        status: this.status,
        fromAgg: {
          id: this.fromAgg_id,
        },
        toAgg: {
          id: this.toAgg_id,
        }
      };

      this.conversionStore.editItem(this.conversion.id, body);
      this.conversions = this.conversionStore.list
      this.conversion_search = this.conversions

     
    },

    deleteIt() {
      this.conversionStore.deleteItem(this.conversion.id);
      this.conversions = this.conversionStore.list
      this.conversion_search = this.conversions
    },


    async loadExchanges() {
      if (!this.exchangeStore.list) {
       await  this.exchangeStore.loadFromApi().then(data => {
         this.exchanges = data
       })
      } else {
        this.exchanges = this.exchangeStore.list
      }

  },


    compileToClipboard(text) {
      navigator.clipboard.writeText(text).then(() => {
        const Toast = Swal.mixin({
          toast: true,
          position: "top-end",
          showConfirmButton: false,
          timer: 3000,
          timerProgressBar: true,
          didOpen: (toast) => {
            toast.onmouseenter = Swal?.stopTimer;
            toast.onmouseleave = Swal?.resumeTimer;
          },
        });
        Toast.fire({
          icon: "success",
          title: "Le texte a été copié dans le presse-papier.",
        });
      });
    },
   
      async loadAggregators() {

      if (!this.aggregatorMethodStore.list) {
        await  this.aggregatorMethodStore.loadFromApi().then(data => {
          this.aggregators = data.filter((ele) => ele.status == true);
          this.fromAgMethods = data.filter((ele) => ele.type === "deposit");
          this.toAgMethods = data.filter((ele) => ele.type == "withdraw");
      })
        } else {
          const data = this.aggregatorMethodStore.list
          this.aggregators = data.filter((ele) => ele.status == true);
          this.fromAgMethods = data.filter((ele) => ele.type === "deposit");
          this.toAgMethods = data.filter((ele) => ele.type == "withdraw");
        }
    },
   
   async onAddItem(){
    Swal.showLoading(null);
     await Promise.all([
      this.loadAggregators(),
      this.loadExchanges()
    ]);
    Swal.close();
    this.doesAddOpen = true;
   },
   async initItem(conversion, action = "edit") {
      this.conversion = conversion;
      this.initData(conversion);
      if (action == "delete") {
        this.doesDeleteOpen = true;
      } else {
        await this.loadAggregators();
        await  this.loadExchanges();
        this.doesEditOpen = true;
      }
    },

    initData(item = null) {
      this.status = item != null ? item.status : "";
      this.gain = item != null ? item.gain : "";
      this.rate = item != null ? item.rate : "";
      //this.from_id = item != null ? item?.from?.id : ""
      //this.to_id = item != null ? item?.to?.id : ""
      this.fromAgg_id = item != null ? item?.fromAgg?.id : "";
      this.toAgg_id = item != null ? item?.toAgg?.id : "";
      // this.exchange_id = item != null ? item?.exchange?.id : ""

    },
  },
  mounted() {
    this.loadFromStore();
    this.doesLoadingOpen = false;
  },
  watch: {
    doesAddOpen: async function () {
      this.errors = [];
      if (!this.doesAddOpen) {
        this.initData(null);
      }
    },
    doesEditOpen: async function () {
      this.errors = [];
      if (!this.doesEditOpen) {
        this.initData(null);
        this.conversion = null;
      }
    },
    doesDeleteOpen: function () {
      if (!this.doesDeleteOpen) {
        this.initData(null);
        this.conversion = null;
      }
    },
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <div class="hstack mb-3" v-show="status != 403">
       <b-button variant="primary" @click="refresh()" class="ms-auto">
        <i class=" bx bx-refresh font-size-16 align-middle me-2"></i>
        Refresh
      </b-button>
      <b-button variant="primary" @click="onAddItem()" class="ms-1">
        <i class="bx bx-plus font-size-16 align-middle me-2"></i>
        Ajouter un nouveau
      </b-button>
    </div>

    <div class="row" v-show="status != 403">
      <div class="col-lg-12">
        <div class="card">
          <div class="card-body">
            <h4 class="card-title">Listes des conversions</h4>
            <p class="card-title-desc">
              Le tableau ci-dessous présente la listes des <code>conversions</code>.
            </p>

            <div class="table-responsive">
              <table class="table align-middle mb-0">
                <thead>
                  <tr>
                    <th>#</th>
                    <!-- <th>Method From</th>
                    <th>Method To</th> -->
                    <th>From Agg.</th>
                    <th>To Agg.</th>
                    <th>Gain</th>
                    <th>Rate</th>
                    <th>Status</th>
                    <th>Last Update</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(conversion, i) in conversions" :key="conversion.id">
                    <th scope="row"  v-on:click="compileToClipboard(conversion.id)"
                                          style="cursor: pointer">{{ i + 1 }}</th>
                    <!-- <td>{{ conversion?.from?.name }}</td>
                    <td>{{ conversion?.to?.name }}</td>  -->
                    <td>
                      {{ conversion?.from?.label_en }} ({{
                        conversion?.fromAgg?.aggregator?.name
                      }})
                    </td>
                    <td>
                      {{ conversion?.to?.label_en }} ({{
                        conversion?.toAgg?.aggregator?.name
                      }})
                    </td>
                    <!-- <td>{{ conversion?.exchange?.from?.name_fr+" à "+conversion?.exchange?.to?.name_fr }}</td>  -->
                    <td>{{ Number(conversion.gain) }}</td>
                    <td>{{ Number(conversion.rate) }}</td>
                    <td>{{ conversion.status ? "Activé" : "Désactivé" }}</td>
                    <td>{{ toDate(conversion.lastUpdate) }}</td>
                    <td class="hstack">
                      <b-button
                        class="btn-sm ms-2"
                        @click="initItem(conversion, 'edit')"
                        variant="success"
                      >
                        <i class="bx bx-edit font-size-16 align-middle mx-1"></i>
                      </b-button>
                      <b-button
                        variant="danger"
                        @click="initItem(conversion, 'delete')"
                        class="ms-2 btn-sm"
                      >
                        <i class="bx bx-trash font-size-16 align-middle mx-1"></i>
                      </b-button>
                      <router-link :to="'/conversions/' + conversion.id">
                        <b-button class="btn-sm ms-2 rounded-pill px-2" variant="primary">
                          Details
                        </b-button>
                      </router-link>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div v-show="status === 403">
      <h3 class="text-danger text-center my-5">Réserver à l'administrateur principal</h3>
    </div>

    <!-- LOADING MODAL -->
    <b-modal
      v-model="doesLoadingOpen"
      id="modal-center"
      centered
      size="md"
      title="Chargement..."
      title-class="font-18"
      hide-footer
    >
      <div class="text-center">
        <div class="spinner-border text-primary-" role="status">
          <span class="visually-hidden">Loading...</span>
        </div>
      </div>
    </b-modal>

    <!-- ADD MODAL -->
    <b-modal
      v-model="doesAddOpen"
      id="modal-center"
      centered
      size="lg"
      title="Ajouter un conversion"
      title-class="font-18"
      hide-footer
    >
      <form @submit.prevent="addItem()">
        <div class="row">
          <div class="col-md-6 mb-3">
            <label for="">Aggreagator From</label>
            <select required v-model="fromAgg_id" class="form-control">
              <option value=""></option>
              <template v-for="aggMethod in fromAgMethods" :key="aggMethod.id">
                <option :value="aggMethod.id">
                  {{ aggMethod.method?.name }}({{ aggMethod?.mode }}
                  {{
                    aggMethod?.max && aggMethod?.max != ""
                      ? Number(aggMethod?.max)
                      : ""
                  }})
                </option>
              </template>
            </select>
          </div>
          <div class="col-md-6 mb-3">
            <label for="">Aggreagator To</label>
            <select
              required
              :disabled="fromAgg_id == ''"
              v-model="toAgg_id"
              class="form-control"
            >
              <option value=""></option>
              <template v-for="aggMethod in toAgMethods" :key="aggMethod.id">
                <option v-if="aggMethod.id !== fromAgg_id" :value="aggMethod.id">
                  {{ aggMethod.method?.name }} ({{ aggMethod.mode }}
                  {{ aggMethod?.max ? Number(aggMethod?.max) : "" }})
                </option>
              </template>
            </select>
          </div>
          <!-- <div class="col-md-6 mb-3">
            <label for="">Echange</label>
            <select v-model="exchange_id" class="form-control">
              <option value="0"></option>
              <template v-for="exchange in exchanges" :key="exchange.id">
                <option :value="exchange.id">{{ exchange.from?.name_fr+" à "+exchange.to?.name_fr }}</option>
              </template>
            </select>
          </div> -->
          <div class="col-md-6 mb-3">
            <label for="">Rate</label>
            <input type="text" v-model="rate" class="form-control" />
          </div>
          <div class="col-md-6 mb-3">
            <label for="">Gain</label>
            <input type="text" v-model="gain" class="form-control" />
          </div>
        </div>
        <div class="mt-3" v-if="!loading">
          <input type="submit" value="Enregistrer" class="btn btn-primary" />
        </div>
        <div class="mt-3 text-center" v-else>
          <div class="spinner-border text-primary" role="status">
            <span class="visually-hidden">Loading...</span>
          </div>
        </div>
      </form>
    </b-modal>

    <!-- EDIT MODAL -->
    <b-modal
      v-model="doesEditOpen"
      id="modal-center"
      centered
      size="lg"
      title="Modifier un conversion"
      title-class="font-18"
      hide-footer
    >
      <form @submit.prevent="editItem()">
        <div class="row">
          <div class="col-md-6 mb-3">
            <label for="">Aggreagator From</label>
            <select required v-model="fromAgg_id" class="form-control">
              <option value="" disabled></option>
              <template v-for="aggregator in fromAgMethods" :key="aggregator.id">
                <option :value="aggregator.id">{{ aggregator.method?.name }}</option>
              </template>
            </select>
          </div>
          <div class="col-md-6 mb-3">
            <label for="">Aggreagator To</label>
            <select
              required
              :disabled="fromAgg_id == ''"
              v-model="toAgg_id"
              class="form-control"
            >
              <option value=""></option>
              <template v-for="aggregator in toAgMethods" :key="aggregator.id">
                <option :value="aggregator.id">{{ aggregator.method?.name }}</option>
              </template>
            </select>
          </div>

          <div class="col-md-6 mb-3">
            <label for="">Status</label>
            <select required v-model="status" class="form-control">
              <option :value="true">Activé</option>
              <option :value="false">Desactivé</option>
            </select>
            <span class="text-danger mt-2" v-if="errors.status">{{ errors.status }}</span>
          </div>
          <div class="col-md-6 mb-3">
            <label for="">Rate</label>
            <input type="text" v-model="rate" class="form-control" />
          </div>
          <div class="col-md-6 mb-3">
            <label for="">Gain</label>
            <input type="text" v-model="gain" class="form-control" />
          </div>
        </div>
        <div class="mt-3" v-if="!loading">
          <input type="submit" value="Enregistrer" class="btn btn-primary" />
        </div>
        <div class="mt-3 text-center" v-else>
          <div class="spinner-border text-primary" role="status">
            <span class="visually-hidden">Loading...</span>
          </div>
        </div>
      </form>
    </b-modal>

    <!-- DELETE MODAL -->
    <b-modal
      v-model="doesDeleteOpen"
      id="modal-center"
      title="Supprimer un conversion"
      title-class="font-18"
      hide-footer
    >
      <p class="mb-2">
        Voulez-vous vraiment supprimer le conversion
        <b>{{ conversion?.from?.name }} - {{ conversion?.to?.name }}</b> ?
      </p>
      <div class="hstack mt-2" v-if="!loading">
        <button class="btn btn-dark ms-auto" @click="doesDeleteOpen = false">
          Annuler
        </button>
        <button class="ms-3 btn btn-danger" @click="deleteIt()">Supprimer</button>
      </div>
      <div class="text-center" v-else>
        <div class="spinner-border text-primary" role="status">
          <span class="visually-hidden">Loading...</span>
        </div>
      </div>
    </b-modal>
  </Layout>
</template>
